import React from "react";

import { BoundingBoxesProvider } from "context/boundingBoxesContext";
import { ImageSettingsProvider } from "context/ImageSettingsContext/imageSettingsContext";
import { Detector } from "types/detectors";
import { ROI } from "types/imageAnnotations";
import { DisplayBBoxInfo, ImageQuery } from "types/imageQueries";
import { LabelValue } from "types/labelValue";
import { checkIsGroundlightBoundingBoxes } from "utils/ReviewPageUtils";

import { GroundlightImageQueryContextConnected } from "./components/GroundlightImageQueryContextConnected";

type GroundlightImageQueryProps = {
  data?: ImageQuery;
  loading?: boolean;
  labelRows?: LabelValue[];
  detector?: Detector;
  onClick?: () => void;
  onSendLabel?: () => Promise<void>;
  isEditing?: boolean;
  enablePanZoom?: boolean;
  hideToolbar?: boolean;
  hideAnswerPanel?: boolean;
  onUnsavedAnnotationsHandled?: (confirmed: boolean) => void;
  showUnsavedAnnotationsWarning?: boolean;
  reviewMode?: boolean;
  reviewBBoxInfo?: DisplayBBoxInfo;
  roisToDisplay?: ROI[] | null;
  selectedLabelValue?: LabelValue | null;
};

export function GroundlightImageQuery({
  onClick,
  enablePanZoom = false,
  isEditing,
  detector,
  data,
  labelRows = [],
  loading = false,
  onSendLabel,
  hideToolbar,
  hideAnswerPanel,
  onUnsavedAnnotationsHandled,
  showUnsavedAnnotationsWarning = false,
  reviewMode = false,
  reviewBBoxInfo,
  roisToDisplay,
  selectedLabelValue,
}: GroundlightImageQueryProps) {
  const isBoundingBoxes = checkIsGroundlightBoundingBoxes(detector);

  return (
    // since zoom, pan and bounding boxes cannot be shared between image queries
    // in the list we use the image query id as key to reset component states
    <React.Fragment key={data?.iq_id}>
      <ImageSettingsProvider isEditing={isEditing}>
        <BoundingBoxesProvider isBoundingBoxes={isBoundingBoxes}>
          <GroundlightImageQueryContextConnected
            detector={detector}
            data={data}
            hideToolbar={hideToolbar}
            hideAnswerPanel={hideAnswerPanel}
            enablePanZoom={enablePanZoom}
            loading={loading}
            onSendLabel={onSendLabel}
            labelRows={labelRows}
            onClick={onClick}
            onUnsavedAnnotationsHandled={onUnsavedAnnotationsHandled}
            showUnsavedAnnotationsWarning={showUnsavedAnnotationsWarning}
            reviewMode={reviewMode}
            reviewBBoxInfo={reviewBBoxInfo}
            roisToDisplay={roisToDisplay}
            selectedLabelValue={selectedLabelValue}
          />
        </BoundingBoxesProvider>
      </ImageSettingsProvider>
    </React.Fragment>
  );
}
